document.addEventListener("DOMContentLoaded", function() {
    const modalElements = document.querySelectorAll("[data-modal-src]");

    modalElements.forEach(ele => {
        const modalID = ele.getAttribute("data-modal-src").replace("#", "");
        const modal = document.getElementById(modalID);

        ele.addEventListener("click", e => {
            e.preventDefault();

            if (modalID === "cite-us") {
                modal
                    .querySelector(".c-modal")
                    .classList.add("c-modal--cite-us");
            }

            if (modalID === "trust-modal") {
                modal.querySelector(".c-modal").classList.add("c-trust-modal");
            }

            //This applies the correct class to the modal and removes the modal from inside the CTA to the body.
            if (modalID === "cta-modal-simple_modal") {
                const ctaCopy = modal;
                modal
                    .querySelector(".c-modal")
                    .classList.add("c-hero-modal", "c-hero-modal--simple");
                modal.remove();
                document.body.appendChild(ctaCopy);
            }

            if (modalID === "cta-modal-uk_modal") {
                modal
                    .querySelector(".c-modal")
                    .classList.add("c-hero-modal", "c-hero-modal--uk");
            }

            if (modalID === "cta-modal-legal_modal") {
                modal
                    .querySelector(".c-modal")
                    .classList.add("c-hero-modal", "c-hero-modal--legal");
            }

            if (modalID === "custom-journey-popup-modal") {
                modal
                    .querySelector(".c-modal")
                    .classList.add("c-cpb-modal", "c-cpb-legal");
            }

            MicroModal.show(modalID, {
                disableScroll: true
            });

            modal.querySelector(".mfp-wrap").style.overflow = "hidden auto";
        });
    });
});

const initAllModals = () => {
    document.addEventListener("click", function(e) {
        if(e.target.closest(".js-imageLightbox")) {
            e.preventDefault();

            openImageModal(e.target.closest(".js-imageLightbox"));
        }

        if(e.target.closest(".js-videoLightbox")) {
            e.preventDefault();

            openVideoModal(e.target.closest(".js-videoLightbox"));
        }

        if (e.target.classList.contains("read-more-quote")) {
            let modalParent = document.querySelector("#testimonial-modal");
            let fullQuote = e.target.closest("[data-content-quote]").dataset
                .contentQuote;
            let name = e.target.closest("[data-content-quote]").dataset
                .contentName;

            modalParent.querySelector(
                ".testimonial-quote-full"
            ).innerHTML = fullQuote;
            modalParent.querySelector(
                ".testimonial-modal-name"
            ).innerHTML = name;
        }
    }); 
}

const openImageModal = (image) => {
    const imageModal = document.getElementById("image-modal");
    let imageRef = image.href;
    let imageAltText = image.alt;

    if (!imageModal) {
        let modalHTML =
            `<div class="modal-wrapper c-lightbox--image" id="image-modal" aria-hidden="true" >
                <div class="mfp-bg" tabindex="-1"></div>
                <div class="mfp-wrap mfp-close-btn-in">
                    <div class="mfp-container" data-micromodal-close>
                        <div class="mfp-content">
                            <div class="mfp-figure">
                            <button class="mfp-close" data-micromodal-close>x</button>
                            <figure> 
                                <img class="mfp-img" alt=${imageAltText} src=${imageRef} style="max-height: 880px;">
                            </figure>
                            </div>
                        </div>
                    </div>
                </div>
            </div>`;

        document.body.insertAdjacentHTML("afterbegin", modalHTML);
    }

    MicroModal.show("image-modal", {
        disableScroll: true,
        onClose: () => {
            document.getElementById("image-modal").remove();
        }
    });
}

const openVideoModal = (video) => {
    const targetElement = findParent(video, ".c-video__link");
    let videoID = targetElement.getAttribute("data-vid");

    if (!document.getElementById("video-modal")) {
        let modalHTML =
            ` <div class="modal-wrapper" id="video-modal" aria-hidden="true" >
                    <div class="mfp-bg"></div>
                    <div class="mfp-wrap mfp-close-btn-in">
                        <div class="mfp-container" data-micromodal-close>
                            <div class="mfp-content">
                            <div class="mfp-iframe-scaler" role="dialog" aria-modal="true" aria-labelledby="modal-1-title">
                            <button class="mfp-close" data-micromodal-close>x</button>
                            <iframe src="https://fast.wistia.net/embed/iframe/` +
            videoID +
            `?autoPlay=true&amp;silentAutoPlay=allow" allowtransparency="true" frameborder="0" scrolling="no" class="wistia_embed" name="wistia_embed" allow="autoplay" allowfullscreen="" mozallowfullscreen="" webkitallowfullscreen="" oallowfullscreen="" msallowfullscreen="" width="640" height="360"></iframe>
                        </div>
                            </div>
                        </div>
                    </div>
            </div>`;

        document.body.insertAdjacentHTML("afterbegin", modalHTML);
    }

    MicroModal.show("video-modal", { 
        disableScroll: true,
        onClose: () => {
            document.getElementById("video-modal").remove();
        }
    });
}

function findParent(element, targetSelector) {
    while (element) {
        if (element.matches(targetSelector)) {
            return element;
        }
        element = element.parentElement;
    }
    return null;
}

initAllModals();
